import { useState, useCallback, useEffect, forwardRef, act } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { FaCalendar } from 'react-icons/fa';
import apiService from '../../../../Auth/apiService.jsx';

registerLocale('es', es);
setDefaultLocale('es');

export const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input
            value={value}
            readOnly
            className='widthCalendar'
            style={{ pointerEvents: 'none',
            background: '#fff',
            border: '1px solid #ced4da',
            padding: '6px 8px',
            borderRadius: 4,
            minWidth: 140,
            marginRight: 8,
            }}
        />
        <FaCalendar size={20} color="black"/>
    </button>
));

CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
};

export function FechaPicker({ control, name = 'fecha', errors }){
    return (
        <DatePicker
            placeholderText="fecha"
            onChange={(date) => control.setValue(name, date)}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            selected={control.getValues(name)}
            customInput={<CustomInput />}
            locale="es"
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
        />
    );
}

FechaPicker.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string,
    errors: PropTypes.object,
};

export function buildColumns(BorrarRenderer) {
    return [
        {
            name: 'Acciones',
            cell: BorrarRenderer,
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Ayuda', selector: row => row.ayuda, sortable: true, width:'10%' },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width: '15%'},
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '15%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
}

export function useAtencionForm({ token, idCabezaFamilia, rol, user, sedeActual, setValue, reset, fetchUrl = '/orientacion/crearformularioregistroatencion' }){
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [entidades, setEntidades] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
    });

    const Mensaje = useCallback((title, text) => {
        setSwalProps({ show: true, title, text });
    }, []);

    const fetchData = useCallback(async () => {
        const url = fetchUrl;
        const obj = { idCabezaFamilia, usrRolid: rol, userId: user };
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            if (result.entidades && Array.isArray(result.entidades)) setEntidades(result.entidades);
            if (result.ayudas && Array.isArray(result.ayudas)) setAyudas(result.ayudas);
            if (result.integrantesdto && Array.isArray(result.integrantesdto)) setIntegrantes(result.integrantesdto);
            if (result.sedes && Array.isArray(result.sedes)) setSedes(result.sedes);
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia}: ${error}`);
        })
        .finally(() => {
            setCargando(false);
            setValue('cabIdcabezafamilia', idCabezaFamilia);
        });
    }, [token, idCabezaFamilia, rol, user, Mensaje, setValue, fetchUrl]);

    const resetForm = useCallback((cleanList) => {
        const fechahoy = new Date();
        fechahoy.setHours(fechahoy.getHours() - 5);
        reset((prevValues) => ({
            ...prevValues,
            sede: sedeActual,
            usrId: user,
            idpersona: idCabezaFamilia,
            ayuda: "",
            entidad: 1,
            fecha: fechahoy,
            cantidad: '1',
            observaciones: "",
            observacionDos: "",
            act_file: null,
            act_fileName: "",
            ate_atencioncerrada: "",
            str_radicadoingreso: "",
            dat_fechaingreso: null,
            dat_fechasalida: null,
            atencionesfields: cleanList ? [] : prevValues.atencionesfields
        }));
    }, [reset, sedeActual, user, idCabezaFamilia]);

    useEffect(() => {
        if (sedes.length > 0 && sedeActual) {
            setValue('sede', sedeActual);
        }
    }, [sedes, sedeActual, setValue]);

    useEffect(() => {
        fetchData().then(() => resetForm(true));
    }, [fetchData, resetForm]);

    return {
        Cargando,
        swalProps,
        setSwalProps,
        Mensaje,
        entidades,
        ayudas,
        integrantes,
        sedes,
        CabezaFamiliaDatos,
        resetForm,
    };
}
